module.exports = "<p>\n  commercial works!\n</p>\n"